/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesSystemBlocks.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for System Block Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 22, 2018 - 6:43 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/22/2018  NJN     File Created
 *      09/24/2018  NJN     Added System Block Validation Types
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const TestList = Loadable({
    loader: () => import('../containers/Testing/TestListContainer'),
    loading: Loading,
});

export const TestEdit = Loadable({
    loader: () => import('../containers/Testing/TestEditContainer'),
    loading: Loading,
});

export const SystemBlockValidationTypeList = Loadable({
    loader: () => import('../containers/SystemBlockValidationTypes/SystemBlockValidationTypeListContainer'),
    loading: Loading,
});

export const SystemBlockValidationTypeEdit = Loadable({
    loader: () => import('../containers/SystemBlockValidationTypes/SystemBlockValidationTypeEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesSystemBlocks.js